import Reveal from "../components/Reveal";

const AWARDS = [
    {
        year: "2014",
        title: "Local Vanguard Award",
        org: "Sacramento Film Festival",
        note: "For contributions to productions throughout the Sacramento area.",
    },
    {
        year: "2000",
        title: "Emerging Artist Award — Cinematography",
        org: "Sacramento Metropolitan Arts Commission",
        note: "Recognizing distinctive early work in cinematography.",
    },
];

const Awards = () => {
    return (
        <main
            data-testid="awards-page"
            className="pt-32 sm:pt-40 pb-32 mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-14"
        >
            <Reveal>
                <p className="text-label text-muted-foreground mb-6">Awards</p>
                <h1 className="font-serif-display text-5xl sm:text-7xl tracking-tighter leading-[1.02] max-w-4xl">
                    Recognition for a <span className="italic text-muted-foreground">quiet, intentional</span> body of work.
                </h1>
            </Reveal>

            <div className="mt-24 max-w-4xl">
                {AWARDS.map((a, i) => (
                    <Reveal key={a.year} delay={i * 150}>
                        <div
                            data-testid={`award-row-${a.year}`}
                            className="grid grid-cols-[88px_1fr] sm:grid-cols-[140px_1fr] gap-6 sm:gap-12 items-start py-12 border-t border-border first:border-t-0"
                        >
                            <span className="font-serif-display text-3xl sm:text-5xl tracking-tighter text-muted-foreground">
                                {a.year}
                            </span>
                            <div>
                                <h2 className="font-serif-display text-2xl sm:text-3xl tracking-tight">
                                    {a.title}
                                </h2>
                                <p className="mt-2 text-label text-muted-foreground">
                                    {a.org}
                                </p>
                                <p className="mt-4 text-base text-foreground/75 leading-relaxed max-w-xl">
                                    {a.note}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </main>
    );
};

export default Awards;
